import { createAccountFetchActions } from '@/providers/wealthica2/store/actions/account-fetch-actions';
import { createPositionFetchActions } from '@/providers/wealthica2/store/actions/position-fetch-actions';
import { createIntegrityActions } from './actions/integrity-actions';
import { createClearActions } from './actions/clear-actions';
import { createAnalyticsActions } from './actions/analytics-actions';

/**
 * Multi-institution account actions for the new multi-connection store
 * Handles account fetching, caching, and management per institution with data integrity
 */
export const createMultiAccountActions = (set: any, get: any) => ({
  // Delegated action modules (extracted for maintainability)
  ...(() => {
    const accountActions = createAccountFetchActions(set, get);
    return {
      fetchAccountsForInstitution: accountActions.fetchAccountsForInstitution,
      refreshAccountsForInstitution: accountActions.refreshAccountsForInstitution,
    };
  })(),
  ...(() => {
    const positionActions = createPositionFetchActions(set, get);
    return {
      loadPositionsForInstitution: positionActions.loadPositionsForInstitution,
    };
  })(),

  // === ANALYTICS / AGGREGATIONS ===
  ...(() => createAnalyticsActions(set, get))(),

  // === CLEAR ACCOUNTS FOR SPECIFIC INSTITUTION ===
  ...(() => createClearActions(set, get))(),

  // === DATA INTEGRITY METHODS ===
  ...(() => createIntegrityActions(set, get))(),
});
